<h2 mat-dialog-title>Change owner</h2>
<mat-dialog-content>
  <p>Select the user this broadcast should be assigned to.</p>
  <app-user-picker label="New owner" (userSelected)="onUserSelected($event)"></app-user-picker>
  <p class="selected-hint" *ngIf="selectedUser">
    New owner: <strong>{{ selectedUser.displayName || selectedUser.email }}</strong>
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="!selectedUser" (click)="confirm()">
    Change owner
  </button>
</mat-dialog-actions>
